import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreFeatureFlagService } from './services';

@NgModule({
  imports: [CommonModule],
  providers: [CoreFeatureFlagService],
})
export class CoreFeatureFlagModule {}
